import CLabel from '@/components/main/CLabel';
import { Description, Favorite, Location, People, SalaryRange, Timer } from '@/components/Svg';
import t from '@/lib/localization';
import Currencies from '@/resources/currencies.json';
import { ActionIcon, Card, Grid, createStyles } from '@mantine/core';
import axios from 'axios';
import dayjs from 'dayjs';
import Link from 'next/link';
import { useEffect, useState } from 'react';

import { useAuthContext } from '@/context/AuthContext';
import { showToaster } from '@/Helpers/hooks/toaster';
import { IconEye } from '@tabler/icons-react';
import SignInModal from '../singin/SignInModal';
import Image from 'next/image';

const useStyles = createStyles((theme) => ({
  avatar: {
    height: '60px',
    width: '60px',
  },
  label: {
    fontSize: '12px',
    lineHeight: '14px',
  },
  comName: {
    color: '#A4A4A4',
    fontSize: '16px',
    lineHeight: '24px',
  },
  para: {
    color: '#A4A4A4',
    fontSize: '14px',
    lineHeight: '24px',
  },
}));

export default function JobCard({ job, dictionary, ...props }) {
  const { user, bookmarks, isBookmark } = useAuthContext();
  const [bookmark, setBookmark] = useState(false);
  const [loginForm, setLoginForm] = useState(false);

  useEffect(() => {
    setBookmark(isBookmark(job.id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(bookmarks)]);

  const handleFavorite = async () => {
    if (user == null) {
      setLoginForm(true);
    } else {
      if (bookmark) {
        try {
          setBookmark(false);
          await axios.delete('/api/favorite-jobs', {
            params: {
              id: job?.id,
            },
            headers: {
              Authorization: user.accessToken,
            },
          });
        } catch (error) {
          setBookmark(true);
        }
      } else {
        if (bookmarks.length >= 30) {
          showToaster(dictionary.bookmarkMessage, 'orange');
        } else {
          try {
            setBookmark(true);
            await axios.post(
              '/api/favorite-jobs',
              {
                id: job?.id,
                orgId: job?.createdBy?.id,
              },
              {
                headers: {
                  Authorization: user.accessToken,
                },
              }
            );
          } catch (error) {
            setBookmark(false);
          }
        }
      }
    }
  };

  const { classes } = useStyles();
  return (
    <>
      <SignInModal show={loginForm} setShow={setLoginForm} dictionary={dictionary}></SignInModal>

      <Card
        padding="lg"
        withBorder
        style={{ borderRadius: '12px' }}
        className={`${props.className} card-hover`}
      >
        <Grid gutter={0} align="center">
          <Grid.Col span={4}>
            <div className="flex items-center">
              <Link
                href={`/jobs/${job?.createdBy?.slug ?? job?.createdBy?.id}/${job.id}`}
                className="no-underline "
              >
                <Image
                  height={50}
                  width={50}
                  
                  className={`${classes.avatar} hover:cursor-pointer rounded-full`}
                  radius="xl"
                  src={job?.createdBy?.photoURL ?? '/images/user.svg'}
                  alt={job?.createdBy?.displayName}
                />
              </Link>
              <div className="ms-4">
                <Link
                  href={`/jobs/${job?.createdBy?.slug ?? job?.createdBy?.id}/${job.id}`}
                  className="no-underline "
                >
                  <h4
                    className="font-semibold text-lg text-grayCustom hover:cursor-pointer hover:text-primary m-0 transition-all duration-200 leading-[22px]
"
                  >
                    {job?.jobTitle}
                  </h4>
                </Link>
                <div className="flex items-center">
                  <h5
                    className={`${classes.comName} me-[16px] m-0 whitespace-nowrap truncate max-w-[200px]`}
                  >
                    {job?.createdBy?.displayName}
                  </h5>
                  <div className="flex items-center truncate text-textGrey ">
                    <Location height="15px" width="11px" />
                    <div
                      className={`${classes.para} ms-[6px]  whitespace-nowrap truncate max-w-[100px]	`}
                    >
                      {job?.location}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Grid.Col>
          <Grid.Col span={4}>
            <div className=" ps-[30px]">
              <div className="flex flex-wrap">
                <CLabel text={job?.jobType} className={`${classes.label} me-[8px] text-xs`} />
                {job?.jobShift.map((shift, i) => (
                  <CLabel key={i} text={shift} className={`${classes.label} me-[8px] text-xs`} />
                ))}
                <div
                  className={`text-primary bg-primaryOpacity font-semibold px-2  rounded-md text-[14px]  m-0 flex items-center `}
                >
                  <IconEye className="me-2" />
                  {job?.viewsCount ?? 0}
                </div>
              </div>
              <div className="flex flex-wrap mt-2">
                <div className="flex items-center text-primary">
                  <Timer width="18" />
                  <div className={`${classes.para} ms-[6px] me-[16px]`}>
                    {dayjs(
                      job?.postingDate.seconds ? job?.postingDate?.toDate() : job?.postingDate
                    ).format('DD MMMM YYYY')}
                  </div>
                </div>
                <div className="flex items-center text-primary">
                  <Timer width="18" />
                  <div className={`${classes.para} ms-[6px]`}>
                    {dayjs(
                      job?.closingDate.seconds ? job?.closingDate?.toDate() : job?.closingDate
                    ).format('DD MMMM YYYY')}
                  </div>
                </div>
              </div>
            </div>
          </Grid.Col>
          <Grid.Col span={3} className="flex flex-col justify-center">
            <div className="flex flex-wrap items-center">
              <div className="flex items-center me-2 text-primary">
                <SalaryRange width="18" />
              </div>
              <div className={`${classes.para} ms-[6px]`}>
                {job?.salaryNotSpecified
                  ? dictionary.notSpecified
                  : `${Currencies[job?.currency]}${job?.minimumSalary} - ${
                      Currencies[job?.currency]
                    }${job?.maximumSalary}`}
              </div>
            </div>
            <div className="flex flex-wrap items-center mt-2">
              <div className="flex items-center me-2 text-primary">
                <People width="18" />
              </div>
              <div className={`${classes.para} ms-[6px]`}>
                {t(dictionary.countVacancies, { count: job?.noOfVacancies })}
              </div>
            </div>
          </Grid.Col>
          <Grid.Col span={1} className="flex items-center space-x-2 lg:justify-end">
            <ActionIcon
              size={'lg'}
              variant={bookmark ? 'filled' : 'outline'}
              onClick={handleFavorite}
              color="blue"
              aria-label={dictionary.bookmark}
              title={dictionary.bookmark}
            >
              <Favorite width="11px" height="16px" />
            </ActionIcon>
            <Link
              href={`/jobs/${job?.createdBy?.slug ?? job?.createdBy?.id}/${job.id}`}
              className="no-underline "
            >
              <ActionIcon
                size={'lg'}
                variant="gradient"
                aria-label={dictionary.details}
                title={dictionary.details}
              >
                <Description />
              </ActionIcon>
            </Link>
          </Grid.Col>
        </Grid>
      </Card>
    </>
  );
}
